import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { timeEntryEndpoints } from '@/lib/api/endpoints';
import { timeEntryKeys } from '@/lib/queryKeys';
import type { ClockInDto, TimeEntry } from '@/types/timeEntry';

export function useClockIn(appointmentId: string, jobId?: string) {
  const queryClient = useQueryClient();
  return useApiMutation<TimeEntry, ClockInDto>({
    mutationFn: (dto) =>
      apiPost<TimeEntry, ClockInDto>(
        operationsClient,
        timeEntryEndpoints.clockIn(appointmentId),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: timeEntryKeys.appointment(appointmentId),
      });
      if (jobId) {
        void queryClient.invalidateQueries({ queryKey: timeEntryKeys.jobRollup(jobId) });
      }
      toast.success('Clocked in');
    },
  });
}
